// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

//added components
import { Container, Grid, List, ListItem, ListItemText } from "@mui/material";

//images
import logoMain from "assets/images/logo-main.svg";
import worldIcon from "assets/images/small-logos/world-icon.svg";
import messageIcon from "assets/images/small-logos/message-icon.svg";
import callIcon from "assets/images/small-logos/call-icon.svg";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

// Authentication layout components
import PageLayout from "examples/LayoutContainers/PageLayout";
import Header from "layouts/home/components/header";
import Footer from "layouts/home/components/footer";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

function TermsAndConditions() {
  const [showButton, setShowButton] = useState(false);
  const [bottomOffset, setBottomOffset] = useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const itemTwo = [
    "Have the legal capacity to agree to these Terms.",
    "Are not a minor in your jurisdiction.",
    "Will not use automated tools or unlawful means to access the Services.",

    "Will comply with all applicable laws.",
  ];
  const itemtre = [
    "<strong>Auto-Renewal:</strong> Subscriptions renew automatically unless canceled.",
    "<strong>Free Trial:</strong> 30-day trial for new users.",
    "<strong>Cancellation:</strong> Cancel anytime; effective at the end of the current billing cycle.",
    "<strong>Fee Changes:</strong> We may adjust subscription fees with notice.",
  ];
  const itemFive = [
    "Use the Services for unlawful purposes.",
    "Interfere with security features or service operations.",
    "Upload harmful code or engage in spamming.",
    "Collect data without permission.",
    "Impersonate others or infringe on intellectual property rights.",
  ];

  return (
    <>
      <Helmet>
        <title> TavloAI Terms & Conditions | Service and Usage Guidelines</title>
        <meta
          name="description"
          content="  Review TavloAI’s Terms & Conditions to understand the rules, rights, and responsibilities when using our AI platform and business solutions."
        />
        <meta name="keywords" content="Terms and conditions" />
      </Helmet>
      <Header />
      <PageLayout>
        <Container
          sx={{
            minHeight: "100vh",
            textAlign: "start",
            maxWidth: "700px",
            margin: "0 auto",
            marginTop: {
              xs: "70px",
              sm: "70px",
              md: "100px",
            },
            marginBottom: "30px",
          }}
        >
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "28px",
                  sm: "38px",
                  md: "48px",
                },
                color: "#000",
              }}
              //  style={{ fontSize: "48px", color: "#292929" }}
            >
              Terms and Conditions
            </MDTypography>
          </MDBox>

          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Last Updated: August 12, 2025
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              1. Agreement to Terms
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            By accessing or using our website https://tavloai.com/ and related
            services ("Services"), you agree to these Terms. If you do not
            agree, discontinue use immediately.
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            These Terms may be updated at any time. Updates will be indicated by
            the "Last Updated" date, and continued use of the Services
            constitutes acceptance.
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Services are intended for users 18 years or older.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              2. Our Services
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Services are not intended for use in jurisdictions where they
            would be unlawful or require special registration. Users are
            responsible for compliance with local laws.
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We do not comply with industry-specific regulations (e.g., HIPAA,
            FISMA, GLBA). Do not use the Services if such compliance is
            required.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              3. Intellectual Property Rights
            </MDTypography>
          </MDBox>

          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            All content, designs, software, and trademarks on the Services are
            owned or licensed by us and protected by law. You are granted a
            limited, non-transferable license to access and use the Services for
            internal business purposes only.
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You may not reproduce, distribute, or exploit any content without
            prior written permission.
          </MDTypography>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              4. User Representations
            </MDTypography>
          </MDBox>

          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            By using the Services, you confirm that you:
          </MDTypography>
          <List sx={{ mb: { xs: 2, sm: 1, md: 2 } }}>
            {itemTwo.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: {
                      xs: "5px",
                      sm: "10px",
                      md: "15px",
                    },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "urbanist",
                      fontWeight: 400,
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      color: "#000",
                      fontFamily: "Poppins",
                      lineHeight: {
                        xs: 2.1,
                        sm: 2.2,
                        md: 2.2,
                      },
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              5. Purchases & Payment
            </MDTypography>
          </MDBox>

          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We accept Visa, Mastercard, PayPal, and American Express. Prices are
            in USD and may change at any time. Sales tax may apply.
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You agree to provide accurate payment details and authorize charges
            for purchases and subscriptions. We reserve the right to refuse or
            limit orders.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              6. Subscriptions
            </MDTypography>
          </MDBox>

          <List sx={{ mb: { xs: 0, sm: 1, md: 2 } }}>
            {itemtre.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: { xs: "5px", sm: "10px", md: "10px" },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={
                    <MDTypography
                      variant="h1"
                      fontWeight="medium"
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: { xs: "10px", sm: "14px", md: "16px" },
                        color: "#000",
                        lineHeight: {
                          xs: "15px",
                          sm: "24px",
                          md: 1.6,
                        },
                        mb: {
                          xs: 1,
                          sm: 0,
                          md: 1.5,
                        },
                        textAlign: "justify",
                      }}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  }
                />
              </ListItem>
            ))}
          </List>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              7. Prohibited Activities
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You may not:
          </MDTypography>
          <List sx={{ mb: { xs: 2, sm: 1, md: 2 } }}>
            {itemFive.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: {
                      xs: "5px",
                      sm: "10px",
                      md: "15px",
                    },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "urbanist",
                      fontWeight: 400,
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      color: "#000",
                      fontFamily: "Poppins",
                      lineHeight: {
                        xs: 2.1,
                        sm: 2.2,
                        md: 2.2,
                      },
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              8. Third-Party Links & Content
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We are not responsible for third-party websites or content accessed
            through our Services. Interactions with third parties are at your
            own risk.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              9. Privacy
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Your use of the Services is subject to our Privacy Policy. By using
            the Services, you consent to the transfer and processing of your
            data in the United States.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              10. Termination
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We may suspend or terminate your access for any reason without
            notice, including violations of these Terms.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              11. Disclaimers
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Services are provided “as is” without warranties of any kind. We
            are not liable for errors, interruptions, or third-party actions.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              12. Limitation of Liability
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We are not liable for indirect, incidental, or consequential
            damages. Our total liability is limited to the amount paid by you in
            the six months preceding the claim.
          </MDTypography>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              13. Indemnification
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You agree to indemnify and hold us harmless from claims arising from
            your use of the Services or breach of these Terms.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              14. Governing Law & Disputes
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            These Terms are governed by the laws of Washington, USA. Disputes
            will be resolved in courts located in Washington, D.C.
          </MDTypography>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "24px",
                  md: "24px",
                },
                color: "#000",
              }}
            >
              15. Contact Us
            </MDTypography>
          </MDBox>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: { xs: "5px", sm: "15px", md: "15px" },
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            TavloAI
          </MDTypography>

          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: { xs: "5px", sm: "15px", md: "15px" },
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Email: <strong> support@tavloai.com</strong>
          </MDTypography>
          <MDTypography
            variant="h1"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: { xs: "5px", sm: "15px", md: "15px" },
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Phone: <strong>(202) 240-7754</strong>
          </MDTypography>
          {showButton && (
            <MDBox
              sx={{
                position: "fixed",
                bottom: bottomOffset,
                right: { xs: 20, md: 35 },
                zIndex: 9999,
              }}
            >
              <MDBox
                onClick={scrollToTop}
                sx={{
                  cursor: "pointer",
                  p: { xs: 0.5, md: 1 },
                  backgroundColor: "#F47C00",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "30px",
                }}
              >
                <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
              </MDBox>
            </MDBox>
          )}
        </Container>
        <Footer />
      </PageLayout>
    </>
  );
}

export default TermsAndConditions;
